import React from "react";
import { Star, Heart, Award } from "lucide-react";

/**
 * PostTypeBadge - Reusable badge component for post types
 * Displays glow, grateful, or proud badges with consistent styling
 *
 * @param {string} postType - The type of post ('glow', 'grateful', 'pride')
 * @param {boolean} isGlowPost - Whether this is a glow post (postType === 'glow' && lumens > 0)
 * @param {string} variant - 'default' for regular posts, 'overlay' for video/YouTube overlays
 */
const PostTypeBadge = ({ postType, isGlowPost, variant = "default" }) => {
	const shadowClass = variant === "overlay" ? "shadow-lg" : "shadow-sm";

	if (isGlowPost) {
		return (
			<div
				className={`flex items-center gap-1 rounded-full bg-yellow-500 px-2 py-0.5 text-xs font-semibold uppercase text-white ${shadowClass}`}
			>
				<Star size={10} className="text-white" />
				<span>Glow</span>
			</div>
		);
	}

	if (postType === "grateful") {
		return (
			<div
				className={`flex items-center gap-1 rounded-full bg-green-500 px-2 py-0.5 text-xs font-semibold uppercase text-white ${shadowClass}`}
			>
				<Heart size={10} className="text-white" />
				<span>Grateful</span>
			</div>
		);
	}

	if (postType === "pride") {
		return (
			<div
				className={`flex items-center gap-1 rounded-full bg-purple-500 px-2 py-0.5 text-xs font-semibold uppercase text-white ${shadowClass}`}
			>
				<Award size={10} className="text-white" />
				<span>Proud</span>
			</div>
		);
	}

	return null;
};

export default PostTypeBadge;
